import { useMediaQuery } from 'react-responsive';
import { DESKTOP, MOBILE, TABLET } from '../pages/constants';

const useScreenMode = () => {
  let screenMode = MOBILE;

  if (useMediaQuery({ minWidth: 767, maxWidth: 1023 })) {
    screenMode = TABLET;
  }
  if (useMediaQuery({ minWidth: 1024 })) {
    screenMode = DESKTOP;
  }

  return screenMode;
};

export default useScreenMode;
